import { intersection } from "lodash";
import { type ProductDetail } from "../types";

export const getIsOptionValueAvailable = (
  variants: ProductDetail.Api.ProductVariant[],
  optionValueIds: string[],
  index: number,
  id: string
): boolean => {
  const optionValueIdsCopy = optionValueIds.slice(0, index);
  optionValueIdsCopy[index] = id;

  return variants.some((x) => {
    return x.isAvailable && intersection(x.optionValueIds, optionValueIdsCopy).length === optionValueIdsCopy.length;
  });
};
